export default function upperCase(value) {
  if (!value) {
    return undefined;
  }

  return value.toString().trim().toUpperCase();
}
